import axios from 'axios'
import getEnv from '../lib/get-env.js'

export const getAccountUserinfo = async ({ bearerToken }) => {
  let accountUserinfo
  try {
    const userAccountInfoResponse = await axios.get(
      `${getEnv('REACT_APP_ACCOUNT_URL')}/v1/userinfo`,
      {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      }
    )
    accountUserinfo = userAccountInfoResponse.data
  } catch (err) {
    console.error(err)
  }

  return accountUserinfo
}
